// Turn the report's columnTags metadata ([{ key, label }]) into an indicators
// object ({ [key]: label }) that can be appended to a table's student-group
// columns so a tagged subset shows as an extra far-right column.
export const tagColumnsToIndicators = (columnTags) =>
  (Array.isArray(columnTags) ? columnTags : []).reduce((acc, c) => {
    if (c && c.key) {
      acc[c.key] = c.label || c.tag || c.key;
    }
    return acc;
  }, {});

export const getValue = (obj, path, key, schoolTypeConversion) => {
  const parts = path.split('.');
  parts.reverse();
  let subObj = obj;
  while (parts.length) {
    subObj = subObj[parts.pop()];
    if (!subObj) return '';
  }

  if (
    schoolTypeConversion &&
    path == 'targets' &&
    subObj[key] &&
    subObj[key][schoolTypeConversion] &&
    subObj[key][schoolTypeConversion].t3
  ) {
    return subObj[key][schoolTypeConversion].t3.toFixed(0);
  }
  return subObj[key];
};

export default 'AtoF/Common/utils.js';
